import React, { Fragment } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const TermsText = dynamic(() => import('../../components/Legal/TermsText'), {
  loading: () => 'Loading...',
});

export default function TermsnCond() {  
  return (
    <main>
      <Head>
        <title>Monet</title>
        <meta name="description" content="Terms and Conditions - General -  Other Agreement - Eligibility
        - Registrations - Privacy & Data Protection - Disclaimers"/>
      </Head>
      <Fragment>
        <TermsText />
      </Fragment>
    </main>
  );
}